<div *ngIf="!admin">
  <clr-datagrid *ngIf="customerSettings" #grid class="customer-settings-list" [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'customerSetting.name'">
      <ng-container i18n='@@customersettings_name'>Name</ng-container>
    </clr-dg-column>
    <clr-dg-column [clrDgField]="'value'">
      <ng-container i18n='@@customersettings_currentvalue'>Current value</ng-container>
    </clr-dg-column>
    <clr-dg-column *ngIf="showAverageTemperature">
      <ng-container i18n='@@customersettings_value'>Value</ng-container>
    </clr-dg-column>
    <clr-dg-column class="cell-edit-mode">
    </clr-dg-column>


    <clr-dg-row *clrDgItems="let item of customerSettings ; index as i" [clrDgItem]="item.customerSetting">
      <clr-dg-cell>{{item.customerSetting.name}}</clr-dg-cell>
      <clr-dg-cell *ngIf="showAverageTemperature && item.value != undefined">{{item.value?.toFixed(1)}} °C</clr-dg-cell>
      <clr-dg-cell *ngIf="showAverageTemperature && item.value == undefined">---</clr-dg-cell>
      <clr-dg-cell *ngIf="editCustomerSetting != item.customerSetting && item.customerSetting.valueType == CustomerSettingsValueType.NUMERIC"> {{item.customerSetting.valueNumeric}}</clr-dg-cell>
      <clr-dg-cell *ngIf="editCustomerSetting != item.customerSetting && item.customerSetting.valueType == CustomerSettingsValueType.STRING"> {{item.customerSetting.valueString}}</clr-dg-cell>
      <clr-dg-cell *ngIf="editCustomerSetting != item.customerSetting && item.customerSetting.valueType == CustomerSettingsValueType.TIMESTAMP"> {{item.customerSetting.valueTimestamp}}</clr-dg-cell>
      <clr-dg-cell *ngIf="editCustomerSetting == item.customerSetting">
      <div class="edit-container">
        <div class="icons-edit-wrapper">
          <label class="edit-label">
              <clr-input-container class="edit-input" *ngIf="item.customerSetting.valueType == CustomerSettingsValueType.NUMERIC">
                <input clrInput placeholder="" class="edit-input" max="9999999" step="0.1" name="customersettingeditvaluenumeric" type="number" [(ngModel)]="editCustomerSetting.valueNumeric" />
              </clr-input-container>
              <clr-input-container class="edit-input" *ngIf="item.customerSetting.valueType == CustomerSettingsValueType.STRING">
                <input clrInput placeholder="" class="edit-input" max="9999999" name="customersettingeditvaluestring" type="text" size="30" [(ngModel)]="editCustomerSetting.valueString" />
              </clr-input-container>
              <clr-input-container class="edit-input" *ngIf="item.customerSetting.valueType == CustomerSettingsValueType.TIMESTAMP">
                <input clrInput placeholder="" class="edit-input" max="9999999" name="customersettingeditvaluetimestamp" type="date" size="30" [(ngModel)]="editCustomerSetting.valueTimestamp" />
              </clr-input-container>
              <cds-icon shape="times" size="md" class="edit-mode" (click)="cancelEditValue()"></cds-icon>
              <cds-icon shape="check" size="md" class="edit-mode" (click)="saveEditValue()"></cds-icon>
          </label>
        </div>
      </div>
      </clr-dg-cell>
      <clr-dg-cell class="cell-edit-mode">
        <cds-icon shape="pencil" size="sm" class="edit-mode" (click)="editValue(item.customerSetting)"></cds-icon>
      </clr-dg-cell>

      <clr-dg-row-detail *clrIfExpanded>
        <cds-icon shape="info-standard" size="sm"></cds-icon>
        <span class="item-description">{{item.customerSetting.description}}</span>
      </clr-dg-row-detail>
    </clr-dg-row>

    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="10">
        <clr-dg-page-size i18n='@@customersettings_settingsperpage' [clrPageSizeOptions]="[10,20,50,100,200]">Settings per page</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}} of {{pagination.totalItems}}
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</div>
